module.exports = __webpack_public_path__ + "0d3b0cd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/articles/leasing/man.png
// module id = 3202
// module chunks = 21